import Resources, { IResource, IResourceApiModel } from './Resource.model';

export interface IManufacturerResources {
  id: number;
  resourcesId: string;
  resource: IResource;
}

export interface IManufacturerResourcesApiModel {
  id: number;
  resourcesId: string;
  resource: IResourceApiModel;
}

export default class ManufacturerResources implements IManufacturerResources {
  public readonly id: number;

  public readonly resourcesId: string;

  public readonly resource: IResource;

  constructor(id: number, resourcesId: string, resource: IResource) {
    this.id = id;
    this.resourcesId = resourcesId;
    this.resource = resource;
  }

  static fromApiModel(apiModel: IManufacturerResourcesApiModel) {
    const { id, resourcesId } = apiModel;

    const resource = Resources.fromApiModel(apiModel.resource);
    return new ManufacturerResources(id, resourcesId, resource);
  }

  static arrayFromApiModel(arrayApiModel: IManufacturerResourcesApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, resourcesId } = apiModel;

      const resource = Resources.fromApiModel(apiModel.resource);

      return new ManufacturerResources(id, resourcesId, resource);
    });

    return array;
  }
}
